import { LabradorComponent } from '@/types/component';
import LabradorRow from 'base/components/labrador/Row';

const MabraLabradorRow: LabradorComponent = ({ type, data, meta, descendants }) => {
  const courseDay = meta.courseDay;
  const id = courseDay ? `dag-${courseDay}` : undefined;

  return <LabradorRow {...{ type, data, meta, descendants, id }} />;
};

export default MabraLabradorRow;
